import axios from 'axios';
import { BASE, getHeaders } from './config';

export function index() {
    return axios.get(`${BASE}/workshops`, { headers: getHeaders() });
}

export default {
    index
}